import React, { useEffect, useState } from "react";
import { downVIcon } from "../../../../assets/icons";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { setUrl } from "../../../../helper/utils";
import "./style.css";

export default function Sorting() {
  const [searchParams] = useSearchParams();
  const [showOptions, setShowOptions] = useState(false);
  const [activeOption, setActiveOption] = useState({
    name: "Recommended",
    value: "recommended",
  });

  const location = useLocation();
  const navigate = useNavigate();

  const options = [
    { name: "Recommended", value: "recommended" },
    { name: "Price: High to Low", value: "highToLow" },
    { name: "Price: Low to High", value: "lowToHigh" },
  ];

  const handleOnClick = (item) => {
    setActiveOption({ name: item.name, value: item.value });
    setShowOptions(false); // close dropdown after selection
  };

  // push value into URL
  useEffect(() => {
    if (activeOption.value) {
      navigate(
        setUrl(location.pathname, searchParams, "sortBy", activeOption.value)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOption.value]);

  // read initial value from URL
  useEffect(() => {
    const paramValue = searchParams.get("sortBy");
    if (paramValue) {
      const found = options.find((item) => item.value === paramValue);
      if (found) {
        setActiveOption({ name: found.name, value: found.value });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return (
    <div className="collection_sorting_container">
      <div
        className="collection_sorting_box"
        onClick={() => setShowOptions((prev) => !prev)}
      >
        <div className="sorting_selected_option">
          <p>
            <span>Filter:</span> {activeOption.name}
          </p>
          <p className="sorting_dropdown_icon">{downVIcon}</p>
        </div>

        {showOptions && (
          <div className="collection_sorting_options_box">
            {options.map((item, index) => (
              <p
                key={index}
                onClick={() => handleOnClick(item)}
                className={
                  activeOption.name === item.name ? "sort_active_option" : ""
                }
              >
                {item.name}
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
